import { PaginatorContainer } from '@components/Paginator/styles';
import { CaretLeft, CaretRight } from '@phosphor-icons/react';
import { useTheme } from 'styled-components';
import { PaginationType } from '../../pages/Home';

type PaginatorProps = {
  totalPages: number;
  currentPage: number;
  take: number;
  onPageChange: (page: PaginationType) => void;
};

export const Paginator = ({
  onPageChange,
  totalPages,
  currentPage,
  take = 9,
}: PaginatorProps) => {
  const theme = useTheme();

  let pages: number[];

  const total = Math.max(1, totalPages);
  const paginationLimit = 3;
  const visiblePages = Math.min(total, paginationLimit);
  const centerOffset = Math.floor(paginationLimit / 2);
  const maxStart = Math.max(total - visiblePages, 0);
  const startPage = Math.max(0, Math.min(currentPage - centerOffset, maxStart));
  pages = Array.from({ length: visiblePages }, (_, i) => startPage + i);

  const handlePage = (page: number) => {
    if (page === currentPage) return;

    onPageChange({ skip: page, take });
  };

  const handlePreviousPage = () => {
    if (currentPage === 0) return;

    onPageChange({ skip: currentPage - 1, take });
  };

  const handleNextPage = () => {
    if (currentPage >= total - 1) return;

    onPageChange({ skip: currentPage + 1, take });
  };

  if (total <= 1) return null;

  return (
    <PaginatorContainer>
      <button
        onClick={handlePreviousPage}
        className="navigation"
        disabled={currentPage === 0}
      >
        <CaretLeft size={18} color={theme.light} />
      </button>

      {pages.map((page) => (
        <button
          key={page}
          className={currentPage === page ? 'active' : ''}
          onClick={() => handlePage(page)}
        >
          {page + 1}
        </button>
      ))}

      <button
        onClick={handleNextPage}
        className="navigation"
        disabled={currentPage >= total - 1}
      >
        <CaretRight size={18} color={theme.light} />
      </button>
    </PaginatorContainer>
  );
};
